module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "'90%'",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl"
  }, [_c('v-card-title', [(_vm.veranstaltung.titel) ? _c('div', [_vm._v(_vm._s(_vm.veranstaltung.titel))]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-2"
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Titel"
    },
    model: {
      value: (_vm.veranstaltung.titel),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "titel", $$v)
      },
      expression: "veranstaltung.titel"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "8",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "veranstaltung.vonDatum",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Beginn",
            "readonly": ""
          },
          model: {
            value: (_vm.formatVonDatum),
            callback: function($$v) {
              _vm.formatVonDatum = $$v
            },
            expression: "formatVonDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": "",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": _vm.changeVonDatum,
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.veranstaltung.vonDatum),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "vonDatum", $$v)
      },
      expression: "veranstaltung.vonDatum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "veranstaltung.vonZeit",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Um",
            "readonly": ""
          },
          model: {
            value: (_vm.veranstaltung.vonZeit),
            callback: function($$v) {
              _vm.$set(_vm.veranstaltung, "vonZeit", $$v)
            },
            expression: "veranstaltung.vonZeit"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_vm._v(" "), _c('v-time-picker', {
    attrs: {
      "allowed-minutes": _vm.allowedMinutes,
      "format": "24hr",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "scrollable": ""
    },
    model: {
      value: (_vm.veranstaltung.vonZeit),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "vonZeit", $$v)
      },
      expression: "veranstaltung.vonZeit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "8",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "veranstaltung.bisDatum",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Ende",
            "readonly": ""
          },
          model: {
            value: (_vm.formatBisDatum),
            callback: function($$v) {
              _vm.formatBisDatum = $$v
            },
            expression: "formatBisDatum"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu3),
      callback: function($$v) {
        _vm.menu3 = $$v
      },
      expression: "menu3"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu3 = false
      }
    },
    model: {
      value: (_vm.veranstaltung.bisDatum),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "bisDatum", $$v)
      },
      expression: "veranstaltung.bisDatum"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4",
      "md": "3"
    }
  }, [_c('v-menu', {
    ref: "veranstaltung.bisZeit",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Um",
            "readonly": ""
          },
          model: {
            value: (_vm.veranstaltung.bisZeit),
            callback: function($$v) {
              _vm.$set(_vm.veranstaltung, "bisZeit", $$v)
            },
            expression: "veranstaltung.bisZeit"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu4),
      callback: function($$v) {
        _vm.menu4 = $$v
      },
      expression: "menu4"
    }
  }, [_vm._v(" "), _c('v-time-picker', {
    attrs: {
      "allowed-minutes": _vm.allowedMinutes,
      "format": "24hr",
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "scrollable": ""
    },
    model: {
      value: (_vm.veranstaltung.bisZeit),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "bisZeit", $$v)
      },
      expression: "veranstaltung.bisZeit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.kleiderordnungen,
      "label": "Kleiderordnung"
    },
    model: {
      value: (_vm.veranstaltung.kleiderordnung),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "kleiderordnung", $$v)
      },
      expression: "veranstaltung.kleiderordnung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Ort"
    },
    model: {
      value: (_vm.veranstaltung.ort),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "ort", $$v)
      },
      expression: "veranstaltung.ort"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "messages": "o/ho",
      "label": "Kategorie"
    },
    model: {
      value: (_vm.veranstaltung.kategorie),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "kategorie", $$v)
      },
      expression: "veranstaltung.kategorie"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Preis"
    },
    model: {
      value: (_vm.veranstaltung.preis),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "preis", $$v)
      },
      expression: "veranstaltung.preis"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "veranstaltung.anmeldungBis",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "clearable": "",
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "label": "Anmeldung bis",
            "readonly": ""
          },
          model: {
            value: (_vm.veranstaltung.anmeldungBis),
            callback: function($$v) {
              _vm.$set(_vm.veranstaltung, "anmeldungBis", $$v)
            },
            expression: "veranstaltung.anmeldungBis"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu5),
      callback: function($$v) {
        _vm.menu5 = $$v
      },
      expression: "menu5"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "prev-icon": "keyboard_arrow_left",
      "next-icon": "keyboard_arrow_right",
      "locale": "de-de",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.menu5 = false
      }
    },
    model: {
      value: (_vm.veranstaltung.anmeldungBis),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "anmeldungBis", $$v)
      },
      expression: "veranstaltung.anmeldungBis"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.itemsKalender,
      "label": "Kalender"
    },
    model: {
      value: (_vm.veranstaltung.kalender),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "kalender", $$v)
      },
      expression: "veranstaltung.kalender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "hint": "Pflichtanmeldungen können nicht mehr bearbeitet werden!",
      "disabled": "",
      "multiple": "",
      "outlined": "",
      "dele": "",
      "deletable-chips": "",
      "chips": "",
      "clearable": "",
      "clear-icon": "close",
      "items": _vm.gruppen,
      "label": "Pflichtanmeldungen"
    },
    model: {
      value: (_vm.veranstaltung.pflichtanmeldungen),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "pflichtanmeldungen", $$v)
      },
      expression: "veranstaltung.pflichtanmeldungen"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "auto-grow": "",
      "rows": "10",
      "label": "Bemerkung"
    },
    model: {
      value: (_vm.veranstaltung.bemerkung),
      callback: function($$v) {
        _vm.$set(_vm.veranstaltung, "bemerkung", $$v)
      },
      expression: "veranstaltung.bemerkung"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(100vh - 364px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Anmeldungen (" + _vm._s(_vm.veranstaltung.anmeldungen ? _vm.veranstaltung.anmeldungen.length : 0) + ")")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.veranstaltung.anmeldungen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(_vm.$filters.user(item, _vm.bbrbbr)))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.anmeldungEntfernen(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.bundesbruder,
      "label": "Bbr hinzufügen",
      "append-outer-icon": "add"
    },
    on: {
      "click:append-outer": _vm.anmeldungHinzufuegen
    },
    model: {
      value: (_vm.neueAnmeldung),
      callback: function($$v) {
        _vm.neueAnmeldung = $$v
      },
      expression: "neueAnmeldung"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "calc(100vh - 364px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("\n                    Weitere Anmeldungen (" + _vm._s(_vm.veranstaltung.weitereAnmeldungen ? _vm.veranstaltung.weitereAnmeldungen.length : 0) + ")\n                  ")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.veranstaltung.weitereAnmeldungen), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.name) + " (" + _vm._s(_vm.$filters.user(item.angemeldetVon, _vm.bbrbbr)) + ")")]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.anmeldungEntfernenWeitere(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-autocomplete', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "items": _vm.bundesbruder,
      "label": "Zugehörigen Bbr"
    },
    model: {
      value: (_vm.neueAnmeldungWeitere.angemeldetVon),
      callback: function($$v) {
        _vm.$set(_vm.neueAnmeldungWeitere, "angemeldetVon", $$v)
      },
      expression: "neueAnmeldungWeitere.angemeldetVon"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Name der Person",
      "append-outer-icon": "add"
    },
    on: {
      "click:append-outer": _vm.anmeldungHinzufuegenWeitere
    },
    model: {
      value: (_vm.neueAnmeldungWeitere.name),
      callback: function($$v) {
        _vm.$set(_vm.neueAnmeldungWeitere, "name", $$v)
      },
      expression: "neueAnmeldungWeitere.name"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDeleteVeranstaltung = true
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "rounded": "",
      "text": "",
      "disabled": _vm.veranstaltung.kalender === '' || _vm.veranstaltung.titel === '' || _vm.formatVonDatum === ''
    },
    on: {
      "click": function($event) {
        return _vm.saveVeranstaltung()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1), _vm._v(" "), _c('dialogDelete', {
    attrs: {
      "visible": _vm.showDeleteVeranstaltung,
      "title": "Veranstaltung löschen",
      "message": "Willst du die Veranstaltung wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
      "abbrechen": "Abbrechen",
      "weiter": "Löschen"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteVeranstaltung = $event
      },
      "closeTrue": function($event) {
        return _vm.deleteVeranstaltung()
      },
      "closeFalse": function($event) {
        _vm.showDeleteVeranstaltung = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d93701aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/dialogVeranstaltungEdit.vue
// module id = 814
// module chunks = 15